/**
 * ANATOMY INTEGRATION MENU PROVIDER — /app/anatomy/*
 * Overview → Follow-ups → Meetings → Administration. Desk pages for Admin + AnatomyAccess (or the
 * Anatomy.View right); Settings for Admin (or Anatomy.Settings).
 */
import {
  IconLayoutDashboard, IconListDetails, IconSend, IconClipboardList, IconCalendarEvent, IconUserPlus, IconUsers,
  IconTestPipe, IconUserSearch, IconActivity, IconSettings,
} from '@tabler/icons-react';
import { DomainMenuProvider, MenuSection, DomainMenuConfig } from '../../layouts/menu/types';
import { anyVisibilityCheck } from './BaseMenuProvider';

class AnatomyMenuProvider implements DomainMenuProvider {
  domainId = 'anatomy';

  getMenuConfig(): DomainMenuConfig {
    const desk = anyVisibilityCheck({ roles: ['Admin', 'AnatomyAccess'] }, { permissions: ['Anatomy.View'] });
    const admin = anyVisibilityCheck({ roles: ['Admin'] }, { permissions: ['Anatomy.Settings'] });

    const sections: MenuSection[] = [
      {
        id: 'anatomy-overview', label: 'Overview', visible: desk,
        items: [{ id: 'anatomy-dashboard', label: 'Dashboard', path: '/app/anatomy', icon: <IconLayoutDashboard size={16} />, visible: desk }],
      },
      {
        id: 'anatomy-follow-ups', label: 'Follow-ups', visible: desk,
        items: [
          { id: 'anatomy-follow-up-types', label: 'Follow-ups', path: '/app/anatomy/follow-ups', icon: <IconListDetails size={16} />, visible: desk },
          { id: 'anatomy-follow-up-send', label: 'Send follow-up', path: '/app/anatomy/follow-ups/new', icon: <IconSend size={16} />, visible: desk },
          { id: 'anatomy-follow-ups-sent', label: 'Sent follow-ups', path: '/app/anatomy/follow-ups/sent', icon: <IconClipboardList size={16} />, visible: desk },
        ],
      },
      {
        id: 'anatomy-meetings', label: 'Meetings', visible: desk,
        items: [
          { id: 'anatomy-meetings-upcoming', label: 'Meetings', path: '/app/anatomy/meetings', icon: <IconCalendarEvent size={16} />, visible: desk },
          { id: 'anatomy-meeting-register', label: 'Register for meeting', path: '/app/anatomy/meetings/register', icon: <IconUserPlus size={16} />, visible: desk },
          { id: 'anatomy-registrations', label: 'Meeting registrations', path: '/app/anatomy/meetings/registrations', icon: <IconUsers size={16} />, visible: desk },
          { id: 'anatomy-meeting-next', label: 'Next meeting (API)', path: '/app/anatomy/meetings/next', icon: <IconTestPipe size={16} />, visible: desk },
        ],
      },
      {
        id: 'anatomy-admin', label: 'Administration', visible: desk,
        items: [
          { id: 'anatomy-test-user', label: 'Test user', path: '/app/anatomy/test-user', icon: <IconUserSearch size={16} />, visible: desk },
          { id: 'anatomy-activity', label: 'Activity', path: '/app/anatomy/activity', icon: <IconActivity size={16} />, visible: desk },
          { id: 'anatomy-settings', label: 'Settings', path: '/app/anatomy/settings', icon: <IconSettings size={16} />, visible: admin },
        ],
      },
    ];

    return { domainId: this.domainId, sections };
  }
}

export const anatomyMenuProvider = new AnatomyMenuProvider();
export default anatomyMenuProvider;
